import { TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";

const AmpHd = ({ sortInfo, createSortHandler }) => {
	const sortLabel = (key, name) => (
		<TableSortLabel
			active={sortInfo.sort === key}
			direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
			onClick={() => createSortHandler(key)}
		>
			{name}
		</TableSortLabel>
	);

	return (
		<TableHead className="engine-module-table">
			<TableRow>
				<TableCell colSpan={5} />
				<TableCell colSpan={3} align="center">Threshold</TableCell>
				<TableCell colSpan={3} align="center">Interval</TableCell>
				<TableCell colSpan={3} align="center">Last Done</TableCell>
				<TableCell colSpan={3} align="center">Next Due</TableCell>
				<TableCell colSpan={3} align="center">Remaining</TableCell>
				<TableCell colSpan={2} />
			</TableRow>
			<TableRow>
				<TableCell style={{ minWidth: '140px' }}>Action(s)</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('MPD_item_no', 'MPD Item No.')}</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('task_card_no', 'Task Card No.')}</TableCell>
				<TableCell style={{ minWidth: '250px' }}>{sortLabel('previous_LDND_Taskcard', 'Previous LDND TaskCard')}</TableCell>
				<TableCell style={{ minWidth: '200px' }}>{sortLabel('Task_Description', 'Task Description')}</TableCell>
				<TableCell>Days</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell>Days</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell>Date</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell>Date</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell>Days</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('remarks', 'Remarks')}</TableCell>
				<TableCell>Attachments</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default AmpHd;
